import { render, staticRenderFns } from "./ViewImages.vue?vue&type=template&id=9f99fe1a&scoped=true&"
import script from "./ViewImages.vue?vue&type=script&lang=js&"
export * from "./ViewImages.vue?vue&type=script&lang=js&"
import style0 from "./ViewImages.vue?vue&type=style&index=0&id=9f99fe1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f99fe1a",
  null
  
)

export default component.exports